import React, { useEffect, useRef, useState } from "react";
import styles from "./ClientsView.module.css";
import { useSelector, useDispatch } from "react-redux";
import Langs, { Localize } from "../../app/lang/langs";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Calendar } from "primereact/calendar";
import ImageButton from "../../components/buttons/ImageButton";
import addIcon from "../../assets/images/add.png";
import addIconFocus from "../../assets/images/addFocus.png";
import exportIcon from "../../assets/images/export.png";
import exportIconFocus from "../../assets/images/exportFocus.png";
import { getSubcontractors } from "../../components/clients/clientsSlice";
import AddSubcontractorModal from "./AddSubcontractorModal";
import { downloadAsset } from "../../assets/assetsSlice";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Dropdown } from "primereact/dropdown";
import { Tag } from "primereact/tag";
import SubcontractorDetailsModal from "./SubcontractorDetailsModal";
import { MultiSelect } from "primereact/multiselect";
import ExcelManager from "../../app/managers/excelManager";
import { FilterService } from 'primereact/api';
import { InputNumber } from "primereact/inputnumber";
import moment from "moment";
import { checkPermission } from "../../app/utils/helpers";
import { config } from "../../app/utils/config";

export default function SubcontractorsTab() {

    const dispatch = useDispatch()
    const subcontractors = useSelector((state) => state.clients.subcontractors)
    const types = useSelector((state) => state.clients.providerTypes)
    const isMobile = useSelector((state) => state.settings.isMobile)
    const [onPreviewSubcontractor, setOnPreviewSubcontractor] = useState(null)
    const [displaySubcontractorDetailsModal, setDisplaySubcontractorDetailsModal] = useState(false)
    const [displayAddSubcontractorModal, setDisplayAddSubcontractorModal] = useState(false)
    const [expandedDatesId, setExpandedDatesId] = useState(null)
    const [expandedDates, setExpandedDates] = useState(false)
    const [expandedCommentsId, setExpandedCommentsId] = useState(null)
    const [expandedComments, setExpandedComments] = useState(false)
    const [expandedAssetsId, setExpandedAssetsId] = useState(null)
    const [expandedAssets, setExpandedAssets] = useState(false)
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        email: { value: null, matchMode: FilterMatchMode.IN },
        type: { value: null, matchMode: FilterMatchMode.IN },
        remiders_comments: { value: null, matchMode: FilterMatchMode.CONTAINS },
        date_attestation_urssaf: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        date_fin_attestation_urssaf: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        date_attestation_fiscale: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        date_fin_attestation_fiscale: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        date_fin_validite_rc: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        date_attestation_salarie_etranger: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        date_fin_attestation_salarie_etranger: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        active_contracts: {
            operator: 'and',
            constraints: [
                { value: 0, matchMode: 'gte' }
            ]
        }
    })
    const [globalFilterValue, setGlobalFilterValue] = useState('')
    const [filteredData, setFilteredData] = useState(null)

    const dt = useRef(null)
    const mounted = useRef(null)
    const canEdit = checkPermission(config.scopes.clientsTeams, config.permissionTypes.edit)

    useEffect(() => {
        if (!mounted.current) {
            dispatch(getSubcontractors())
        }
        mounted.current = true
    }, [mounted])

    const remiderDatesTemplate = (rowData) => {
        const datesArray = rowData.reminders_dates ? rowData.reminders_dates.split('\n').filter(date => date.trim() !== "") : [];
        return (
            <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
                {datesArray.slice(0, expandedDates && expandedDatesId === rowData.id ? datesArray.length : 3).map((date, index) => (
                    <li key={index} style={{
                        position: 'relative',
                        paddingLeft: '20px',
                        wordWrap: 'break-word',
                        maxWidth: '35ch',
                        marginBottom: '8px'
                    }}>
                        <span style={{
                            position: 'absolute',
                            left: '0',
                            top: '0'
                        }}>•</span>
                        {date}
                    </li>
                ))}
                {datesArray.length > 3 && !expandedDates && expandedDatesId !== rowData.id && (
                    <li style={{ cursor: 'pointer', color: 'blue' }} onClick={() => { setExpandedDates(true); setExpandedDatesId(rowData.id) }}>
                        ... {<Langs str="SHOW_MORE" />} ({datesArray.length - 3} {<Langs str="MORE" />})
                    </li>
                )}
                {expandedDates && expandedDatesId === rowData.id && datesArray.length > 3 && (
                    <li style={{ cursor: 'pointer', color: 'blue' }} onClick={() => { setExpandedDates(false); setExpandedDatesId(null) }}>
                        {<Langs str="SHOW_LESS" />}
                    </li>
                )}
                {expandedDates && expandedDatesId !== rowData.id && datesArray.length > 3 && (
                    <li style={{ cursor: 'pointer', color: 'blue' }} onClick={() => { setExpandedDates(true); setExpandedDatesId(rowData.id) }}>
                        ... {<Langs str="SHOW_MORE" />} ({datesArray.length - 3} {<Langs str="MORE" />})
                    </li>
                )}
            </ul>
        )
    }

    const remiderCommentsTemplate = (rowData) => {
        const commentsArray = rowData.reminders_comments ? rowData.reminders_comments.split('\n') : [];
        return (
            <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
                {commentsArray.slice(0, expandedComments && expandedCommentsId === rowData.id ? commentsArray.length : 3).map((comment, index) => (
                    <li key={index} style={{
                        position: 'relative',
                        paddingLeft: '20px',
                        wordWrap: 'break-word',
                        maxWidth: '35ch',
                        marginBottom: '8px'
                    }}>
                        <span style={{
                            position: 'absolute',
                            left: '0',
                            top: '0'
                        }}>•</span>
                        {comment}
                    </li>
                ))}
                {commentsArray.length > 3 && !expandedComments && expandedCommentsId !== rowData.id && (
                    <li style={{ cursor: 'pointer', color: 'blue' }} onClick={() => { setExpandedComments(true); setExpandedCommentsId(rowData.id) }}>
                        ... {<Langs str="SHOW_MORE" />} ({commentsArray.length - 3} {<Langs str="MORE" />})
                    </li>
                )}
                {expandedComments && expandedCommentsId === rowData.id && commentsArray.length > 3 && (
                    <li style={{ cursor: 'pointer', color: 'blue' }} onClick={() => { setExpandedComments(false); setExpandedCommentsId(null) }}>
                        {<Langs str="SHOW_LESS" />}
                    </li>
                )}
                {expandedComments && expandedCommentsId !== rowData.id && commentsArray.length > 3 && (
                    <li style={{ cursor: 'pointer', color: 'blue' }} onClick={() => { setExpandedComments(true); setExpandedCommentsId(rowData.id); }}>
                        ... {<Langs str="SHOW_MORE" />} ({commentsArray.length - 3} {<Langs str="MORE" />})
                    </li>
                )}
            </ul>
        )
    }

    const statusBodyTemplate = (rowData) => {
        return <div style={{ color: (["Présent", "Actif"].includes(rowData.status) ? "green" : "red") }}>
            {rowData.status}
        </div>
    }

    function getFilteredData() {
        return filteredData ?? subcontractors
    }

    const exportFilteredProviders = () => {
        let exportList = getFilteredData().reduce((array, current) => {
            let data = {
                "Nom": current.name || "",
                "Status": current.status || "",
                "Type": current.type || "",
                "Contracts actifs": current.active_contracts || 0,
                "Code Fournisseur V-Fact": current.vfact || "",
                "Address": current.address || "",
                "Date d'attestation URSSAF": current.date_attestation_urssaf ? formatDate(current.date_attestation_urssaf) : "",
                "Date de fin d'attestation URSSAF": current.date_fin_attestation_urssaf ? formatDate(current.date_fin_attestation_urssaf) : "",
                "Date d'attestation fiscale": current.date_attestation_fiscale ? formatDate(current.date_attestation_fiscale) : "",
                "Date de fin d'attestation fiscale": current.date_fin_attestation_fiscale ? formatDate(current.date_fin_attestation_fiscale) : "",
                "Date de fin de validité RC": current.date_fin_validite_rc ? formatDate(current.date_fin_validite_rc) : "",
                "Date d'attestation salarié étranger": current.date_attestation_salarie_etranger ? formatDate(current.date_attestation_salarie_etranger) : "",
                "Date de fin d'attestation salarié étranger": current.date_fin_attestation_salarie_etranger ? formatDate(current.date_fin_attestation_salarie_etranger) : "",
                "Dates de rappel": current.reminders_dates || "",
                "Commentaires de rappel": current.reminders_comments || "",
            }

            array.push(data)
            return array
        }, [])
        ExcelManager.getInstance().generateAndDownloadExcelFromData(exportList, "fournisseurs")
    }

    const formatDate = (value) => {
        return value.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        })
    }

    const creationDateBodyTemplate = (rowData, column) => {
        if (rowData[column.field]) {
            return <label>
                {moment(rowData[column.field]).format("DD/MM/YYYY HH:mm")}
            </label>
        }
    }

    const dateBodyTemplate = (rowData, column) => {

        const dateValue = rowData[column.field];

        if (!dateValue) {
            return <span style={{ color: 'red' }}>{Localize('NOT_AVAILABLE')}</span>;
        }

        const dateObj = new Date(dateValue);
        const now = new Date();

        if (column.field.includes('fin') && dateObj < now) {
            return <span style={{ color: 'orange' }}>{formatDate(dateObj)}</span>;
        }

        return <span>{formatDate(dateObj)}</span>;
    }

    const dateFilterTemplate = (options) => {
        return <Calendar
            value={options.value}
            onChange={(e) => options.filterCallback(e.value, options.index)}
            dateFormat="dd/mm/yy"
            placeholder="dd/mm/yyyy"
            mask="99/99/9999"
        />
    }

    const assetsTemplate = (rowData) => {
        const assetsArray = rowData.assets || [];
        return (
            <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
                {assetsArray.slice(0, expandedAssets && expandedAssetsId === rowData.id ? assetsArray.length : 3).map((asset, index) => (
                    <li
                        key={index}
                        style={{
                            position: 'relative',
                            paddingLeft: '20px',
                            wordWrap: 'break-word',
                            maxWidth: '35ch',
                            marginBottom: '8px'
                        }}
                    >
                        <span
                            style={{
                                position: 'absolute',
                                left: '0',
                                top: '0'
                            }}
                        >
                            •
                        </span>
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                dispatch(
                                    downloadAsset({
                                        tableName: asset.table_name,
                                        idParent: asset.id_parent,
                                        filename: asset.filename,
                                    })
                                );
                            }}
                            style={{
                                textDecoration: 'none',
                                color: 'blue',
                                cursor: 'pointer',
                            }}
                        >
                            {asset.filename}
                        </a>
                    </li>
                ))}
                {assetsArray.length > 3 && !expandedAssets && expandedAssetsId !== rowData.id && (
                    <li style={{ cursor: 'pointer', color: 'blue' }} onClick={() => { setExpandedAssets(true); setExpandedAssetsId(rowData.id); }}>
                        ... {<Langs str="SHOW_MORE" />} ({assetsArray.length - 3} {<Langs str="MORE" />})
                    </li>
                )}
                {expandedAssets && expandedAssetsId === rowData.id && assetsArray.length > 3 && (
                    <li style={{ cursor: 'pointer', color: 'blue' }} onClick={() => { setExpandedAssets(false); setExpandedAssetsId(null); }}>
                        {<Langs str="SHOW_LESS" />}
                    </li>
                )}
                {expandedAssets && expandedAssetsId !== rowData.id && assetsArray.length > 3 && (
                    <li style={{ cursor: 'pointer', color: 'blue' }} onClick={() => { setExpandedAssets(true); setExpandedAssetsId(rowData.id); }}>
                        ... {<Langs str="SHOW_MORE" />} ({assetsArray.length - 3} {<Langs str="MORE" />})
                    </li>
                )}
            </ul>
        )
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    }

    const renderHeader = () => {
        return (
            <div className="d-flex justify-content-between" style={{ width: '100%' }}>
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                </IconField>
                <div>
                    <ImageButton
                        image={exportIcon}
                        imageFocus={exportIconFocus}
                        onClick={exportFilteredProviders}
                        active={true}
                        tooltip="Export"
                        width={32} />
                    {canEdit && <ImageButton
                        image={addIcon}
                        imageFocus={addIconFocus}
                        onClick={() => setDisplayAddSubcontractorModal(true)}
                        active={true}
                        tooltip={<Langs str="ADD_SUBCONTRACTOR" />}
                        width={32} />}
                </div>
            </div>
        )
    }

    const getSeverity = (status) => {
        switch (status) {
            case 'Inactif':
                return 'danger'
            case 'Actif':
                return 'success'
            case 'new':
                return 'info'
            case 'negotiation':
                return 'warning'
            case 'renewal':
                return null
        }
    }

    const statusItemTemplate = (option) => {
        return <Tag value={option.value} severity={getSeverity(option.label)} />;
    }

    const statusRowFilterTemplate = (options) => {

        const status = [
            { label: 'Actif', value: 'Actif' },
            { label: 'Inactif', value: 'Inactif' },
        ]
        return (
            <Dropdown
                value={options.value}
                options={status}
                onChange={(e) => options.filterApplyCallback(e.value)}
                itemTemplate={statusItemTemplate}
                placeholder={<Langs str={"Select One"} />}
                className="p-column-filter"
                showClear
                style={{ minWidth: '12rem' }} />
        )
    }

    const typeRowFilterTemplate = (options) => {

        return <MultiSelect
            value={options.value}
            options={types}
            onChange={(e) => options.filterApplyCallback(e.value)}
            optionLabel="label"
            placeholder={<Langs str={"Select Many"} />}
            className="p-column-filter" />
    }

    const filterNumericData = (options) => {
        return <InputNumber
            value={options.value}
            onValueChange={(e) =>
                options.filterApplyCallback(e.value)
            }
            min={0}
            mode="decimal"
            showButtons
        />
    }

    const header = renderHeader()

    const onRowDoubleClick = (e) => {
        setDisplaySubcontractorDetailsModal(true)
        setOnPreviewSubcontractor(e.data)
    }

    return (
        <div className={styles.bodyContainer}>
            <div className="card p-1 mt-3" style={{ height: 'calc(100vh - 160px)' }}>
                <DataTable ref={dt}
                    value={subcontractors}
                    onValueChange={(data) => setFilteredData(data)}
                    scrollHeight={isMobile === 2 ? "calc(100vh - 200px)" : "calc(100vh - 305px)"}
                    scrollable
                    paginator
                    sortMode="single"
                    globalFilterFields={['name', 'status', 'type', 'email', 'remiders_comments']}
                    filters={filters}
                    header={header}
                    onRowDoubleClick={canEdit ? onRowDoubleClick : undefined}
                    selectionMode={'single'}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    rowsPerPageOptions={[10, 25, 50]}
                    rows={25}
                    currentPageReportTemplate={`{first} ${Localize("to")} {last} ${Localize("of")} {totalRecords}`}
                >
                    <Column field="name" filter filterMatchMode={'contains'} filterPlaceholder="nom" sortable header={<Langs str='Nom' />} style={{ minWidth: '12rem' }} />
                    <Column field="status" filter showFilterMatchModes={false} filterElement={statusRowFilterTemplate} sortable header={<Langs str='STATUS' />} body={statusBodyTemplate} style={{ minWidth: '5rem' }} />
                    <Column field="type" filter showFilterMatchModes={false} filterElement={typeRowFilterTemplate} sortable header={<Langs str='TYPE' />} style={{ minWidth: '9rem' }} />
                    <Column field="active_contracts" dataType="numeric"
                        filter
                        filterElement={filterNumericData}
                        sortable header={<Langs str='active_contracts' />} body={(d) => <strong className={d.active_contracts ? "" : "error"}>{d.active_contracts}</strong>} style={{ minWidth: '5rem' }} />
                    <Column field="vfact" sortable header={<Langs str='Code Fournisseur V-Fact' />} style={{ minWidth: '10rem' }} />
                    <Column field="email" header={<Langs str='EMAIL' />} style={{ minWidth: '9rem' }} />
                    <Column field="address" header={<Langs str='ADDRESS' />} style={{ minWidth: '12rem' }} />
                    <Column sortable header={Localize('DATE_ATTESTATION_URSSAF')} field="date_attestation_urssaf" filterField="date_attestation_urssaf" dataType="date" style={{ minWidth: '10rem' }} body={dateBodyTemplate} filter filterElement={dateFilterTemplate} />
                    <Column sortable header={Localize('DATE_FIN_ATTESTATION_URSSAF')} field="date_fin_attestation_urssaf" filterField="date_fin_attestation_urssaf" dataType="date" style={{ minWidth: '10rem' }} body={dateBodyTemplate} filter filterElement={dateFilterTemplate} />
                    <Column sortable header={Localize('DATE_ATTESTATION_FISCALE')} field="date_attestation_fiscale" filterField="date_attestation_fiscale" dataType="date" style={{ minWidth: '10rem' }} body={dateBodyTemplate} filter filterElement={dateFilterTemplate} />
                    <Column sortable header={Localize('DATE_FIN_ATTESTATION_FISCALE')} field="date_fin_attestation_fiscale" filterField="date_fin_attestation_fiscale" dataType="date" style={{ minWidth: '10rem' }} body={dateBodyTemplate} filter filterElement={dateFilterTemplate} />
                    <Column sortable header={Localize('DATE_FIN_VALIDITE_RC')} field="date_fin_validite_rc" filterField="date_fin_validite_rc" dataType="date" style={{ minWidth: '10rem' }} body={dateBodyTemplate} filter filterElement={dateFilterTemplate} />
                    <Column sortable header={Localize('DATE_ATTESTATION_SALARIE_ETRANGER')} field="date_attestation_salarie_etranger" filterField="date_attestation_salarie_etranger" dataType="date" style={{ minWidth: '10rem' }} body={dateBodyTemplate} filter filterElement={dateFilterTemplate} />
                    <Column sortable header={Localize('DATE_FIN_ATTESTATION_SALARIE_ETRANGER')} field="date_fin_attestation_salarie_etranger" filterField="date_fin_attestation_salarie_etranger" dataType="date" style={{ minWidth: '10rem' }} body={dateBodyTemplate} filter filterElement={dateFilterTemplate} />
                    <Column field="remiders_dates" header={<Langs str='REMINDERS_DATES' />} body={remiderDatesTemplate} style={{ minWidth: '3rem' }} />
                    <Column field="remiders_comments" header={<Langs str='REMINDERS_COMMENTS' />} body={remiderCommentsTemplate} style={{ minWidth: '20rem' }} />
                    <Column field="created_at" header={Localize("created_at")} body={creationDateBodyTemplate} sortable dataType="date" style={{ minWidth: '9rem' }}></Column>
                    <Column field="assets" header={<Langs str='Assets' />} body={assetsTemplate} style={{ minWidth: '20rem' }} />
                </DataTable>
            </div>
            <AddSubcontractorModal
                visible={displayAddSubcontractorModal}
                onHide={() => setDisplayAddSubcontractorModal(false)}
            />
            <SubcontractorDetailsModal
                visible={displaySubcontractorDetailsModal}
                setVisible={setDisplaySubcontractorDetailsModal}
                subcontractor={onPreviewSubcontractor}
                setSubcontractor={setOnPreviewSubcontractor}
            />
        </div>
    )
}
